import { isTruthy } from '../../../utils/isTruthy.mjs';

const mergeSx = (...args)=>args.filter(isTruthy).flat();

export { mergeSx };
//# sourceMappingURL=mergeSx.mjs.map
